import styled from 'styled-components'
import logoImg from '../assets/logo2.png'
import closeImg from '../assets/close2.png'
import { useSelector } from 'react-redux'
import { setCookie, getSelectedCategory } from '../utils/cookie'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

function HeaderMobile() {
  const categoryList = useSelector((state) => state.category.category)
  const navigate = useNavigate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleCategoryClick = (caSeq) => {
    setCookie('selectedCategory', caSeq)
    navigate(`/category/${caSeq}`)
    setIsMenuOpen(false)
  }

  return (
    <>
      <MainContainer>
        <Logo
          src={logoImg}
          onClick={() => {
            navigate('/')
          }}
        />
        {isMenuOpen ? (
          <CloseButton onClick={() => setIsMenuOpen(false)} aria-label="메뉴 닫기">
            <CloseIcon src={closeImg} alt="" />
          </CloseButton>
        ) : (
          <MenuButton onClick={() => setIsMenuOpen(true)} aria-label="메뉴 열기">
            <HamburgerIcon>
              <span />
              <span />
              <span />
            </HamburgerIcon>
          </MenuButton>
        )}
      </MainContainer>

      <Backdrop $isOpen={isMenuOpen} onClick={() => setIsMenuOpen(false)} />
      <Drawer $isOpen={isMenuOpen}>
        <MenuList>
          {categoryList?.map((category) => (
            <MenuItem
              key={category.caSeq}
              $selected={getSelectedCategory() == category.caSeq}
              onClick={() => handleCategoryClick(category.caSeq)}
            >
              {category.caName}
            </MenuItem>
          ))}
        </MenuList>
      </Drawer>
    </>
  )
}

export default HeaderMobile

const MainContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 66px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  background: #fff;
  z-index: 1002;
`
const Logo = styled.img`
  width: auto;
  height: 24px;
  margin-left: 29.1px;
  margin-bottom: 21.4px;
  cursor: pointer;
`
const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 29.1px;
  margin-bottom: 17.4px;
  padding: 6px;
  background: none;
  border: none;
  cursor: pointer;
`
const CloseButton = styled(MenuButton)``
const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
`
const HamburgerIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;

  span {
    display: block;
    height: 3px;
    background: #000;
    width: 100%;
  }
`
const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`
const Drawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 70vw;
  height: 100vh;
  background: #fff;
  z-index: 1001;
  transform: translateX(${(props) => (props.$isOpen ? '0' : '100%')});
  transition: transform 0.3s ease;
  padding-top: 120px;
`
const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin-left: 20px;
  gap: 40px;
`
const MenuItem = styled.p`
  font-family: GmarketSans;
  font-weight: bold;
  font-size: 18px;
  color: '#000';
  cursor: pointer;
`
